var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card"},[(_vm.$slots.title)?_c('div',{staticClass:"head"},[_c('span',{staticClass:"title"},[_vm._t("title")],2),_vm._v(" "),_c('span',{staticClass:"title-r"},[_vm._t("title-r")],2)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"body"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }